import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Banner } from '../models/banner';

@Injectable({
  providedIn: 'root'
})
export class BannerAdvancedService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/config/slider/advanced";


  getSliderData(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/all?page=${Page}&size=${size}&sort=${sort}`);
  }

  saveBannerData(banner: Banner): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, banner)
  }

  deleteBannerData(banner:any): Observable<Response[]> {
    return this.http.put<Response[]>(`${this.url}`, banner)
  }
}
